import { Selector } from '@ngxs/store';

import { Spinner, BcStateContext } from '@bayclubs/state';
import { BlockedSlotInfoModel, CourtBookingInfoModel, CourtClassInfoModel } from '@bayclubs/court-booking-employee-api';

import { CourtEventInfoStateModel } from './court-event-info.state.model';
import { CourtEventInfoState } from './court-event-info.state';

export class CourtEventInfoSelectors {
    @Selector([CourtEventInfoState])
    static blockedSlotDetails(state: CourtEventInfoStateModel): BcStateContext<BlockedSlotInfoModel> {
        return state.blockedSlotDetails;
    }

    @Selector([CourtEventInfoState])
    static spinner(state: CourtEventInfoStateModel): Spinner {
        return state.spinner;
    }

    @Selector([CourtEventInfoState])
    static courtBookingDetails(state: CourtEventInfoStateModel): BcStateContext<CourtBookingInfoModel> {
        return state.courtBookingDetails;
    }

    @Selector([CourtEventInfoState])
    static courtClassDetails(state: CourtEventInfoStateModel): BcStateContext<CourtClassInfoModel> {
        return state.courtClassDetails;
    }
}
